import { render, staticRenderFns } from "./access-form.vue?vue&type=template&id=289eceba"
import script from "./access-form.vue?vue&type=script&lang=js"
export * from "./access-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports